var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scenarios-page"},[_c('autoplay-video',_vm._l((_vm.videos),function(video){return _c('source',{key:video.url,attrs:{"src":video.url,"type":video.type}})}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }